<script>
import ModelCreate from "../models/create";
import FormsModel from "@/components/forms/balancing_payment";
import { serialize } from 'object-to-formdata';

export default {
  extends: ModelCreate,
  page: {
    title: "Create Balancing Payment",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('balancing_payments.singular')) }},
    resourceRoute: {default: 'balancing_payments'},
    modelVariable: {default: 'balancing_payment'},
    form: {default() { return FormsModel; }}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.plural`)),
      items: [
        {
          text: this.lodash.upperFirst(this.$t(`${this.resourceRoute}.plural`)),
          href: "/balancing_payments",
        },
        {
          text: this.$t("Create New"),
          href: "/balancing_payments/create",
          active: true,
        },
      ]
    }
  },
  methods: {
    paymentPayload({
        ticket_id,
        from_bank_account_id,
        to_bank_account_id,
        invoice_number,
        paid_at,
        credit,
        description,
        optional_files,
        transfer_slip,
        invoice_document,
        paymentables
    }) {
      let files = optional_files.map(v => ({ ...v, path: v.file }))

      if (transfer_slip.file) {
        files.push({ ...transfer_slip, name: 'transfer slip', path: transfer_slip.file})
      }

      if (invoice_document.file) {
        files.push({ ...invoice_document, name: 'invoice document', path: invoice_document.file })
      }

      return {
        ticket_id,
        from_bank_account_id,
        to_bank_account_id,
        invoice_number,
        paid_at,
        credit,
        description,
        files: files,
        paymentables: paymentables.map(({
          paymentable_id,
          paymentable_type,
          credit
        }) => ({
          paymentable_id,
          paymentable_type,
          credit,
        })),
      }
    },
    store(value) {
      return this.$axios.post('payments', (
          serialize({...value}, { indices: true,booleansAsIntegers: true})
      ));
    },
    handleStore(value) {
      this.storing = true;

      this.store(this.paymentPayload(value))
      .then((response) => {
        const {
          data: {
            data: {
              id
            } = {}
          } = {}
        } = response;
        this.storeSuccessAlert(`dengan ID ${id}`);
      })
      .then(() => {
        this.isEditing = false;
        return this.$router.back()
      })
      .catch((error) => this.failedAlert(error))
      .finally(() => { this.storing = false })
    },
  }
}
</script>
